import { render } from "./VGoalPanel.vue?vue&type=template&id=467bd19a&ts=true"
import script from "./VGoalPanel.vue?vue&type=script&lang=ts"
export * from "./VGoalPanel.vue?vue&type=script&lang=ts"

import "./VGoalPanel.vue?vue&type=style&index=0&id=467bd19a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__